/* Subheaders de Habitaciones y Experiencias.
   El scroll lo resuelve position: sticky. Solo se mide al cambiar tamaño,
   idioma o página para dejar las fichas y la pila debajo del encabezado. */
(function () {
  'use strict';
  var grupos = [
    { section: document.querySelector('.hab-sec'), head: document.querySelector('.hab-top') },
    { section: document.querySelector('.itin'), head: document.querySelector('.itin-head') }
  ];
  var pendiente = 0;
  var tarjetas = document.querySelectorAll('.itin-card');
  function medir() {
    pendiente = 0;
    grupos.forEach(function (g) {
      if (!g.section || !g.head || !g.head.offsetHeight) return;
      // Un encabezado sin anclar (Experiencias en móvil, pantallas bajas) no
      // tapa nada al recorrer: su alto no se descuenta.
      var h = getComputedStyle(g.head).position === 'sticky' ? Math.ceil(g.head.getBoundingClientRect().height) : 0;
      if (g.height !== h) {
        g.height = h;
        g.section.style.setProperty('--section-head-h', h + 'px');
      }
    });
    tarjetas.forEach(function (card) {
      if (!card.offsetHeight) return;
      var h = card.offsetHeight;
      if (card._subheaderHeight !== h) {
        card._subheaderHeight = h;
        card.style.setProperty('--card-full-h', h + 'px');
      }
    });
  }
  function programar() {
    if (!pendiente) pendiente = requestAnimationFrame(medir);
  }
  if (window.ResizeObserver) {
    var observer = new ResizeObserver(programar);
    grupos.forEach(function (g) { if (g.head) observer.observe(g.head); });
    tarjetas.forEach(function (card) { observer.observe(card); });
  }
  var paginas = new MutationObserver(programar);
  document.querySelectorAll('.page').forEach(function (p) {
    paginas.observe(p, { attributes: true, attributeFilter: ['hidden', 'class'] });
  });
  window.addEventListener('resize', programar);
  document.addEventListener('i18n:change', programar);
  if (document.fonts) document.fonts.ready.then(programar);
  programar();
})();
